import type React from 'react';
import { AdornedInput, FormField, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { SECURITY_DEPOSIT } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function InterestRate({ section, setSectionValues }: Props) {
  function onInterestRateChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [SECURITY_DEPOSIT.FIELD_NAME.INTEREST_RATE]: value,
    });
  }

  return (
    <FormField
      required
      label={<Label>What is the security deposit interest rate?</Label>}
      control={
        <AdornedInput.Root>
          <AdornedInput.Input
            value={section.getFieldValue(SECURITY_DEPOSIT.FIELD_NAME.INTEREST_RATE)}
            onChange={onInterestRateChange}
            type="number"
          />
          <AdornedInput.Adornment>%</AdornedInput.Adornment>
        </AdornedInput.Root>
      }
    />
  );
}

InterestRate.description =
  'Asks what the security deposit interest rate is depending on if they chose option.  Optional screen';

export default InterestRate;
